<template>
  <tr>
    <td id="name" nowrap>
      <popper
        trigger="hover"
        :options="{
          placement: 'top',
          modifiers: { offset: { offset: '0,10px' } },
        }"
      >
        <div class="popper">
          {{ recentPlacement.candidate_name }}
        </div>
        <div slot="reference" class="truncate-item">
          <router-link
            style="text-decoration: none"
            :to="{
              name: 'manager_candidate_id',
              params: { manager_candidate_id: recentPlacement.candidate_id },
            }"
          >
            {{ recentPlacement.candidate_name }}
          </router-link>
        </div>
      </popper>
    </td>
    <td id="job">
      <popper
        trigger="hover"
        :options="{
          placement: 'top',
          modifiers: { offset: { offset: '0,10px' } },
        }"
      >
        <div class="popper">
          {{ recentPlacement.job }}
        </div>
        <div slot="reference" class="truncate-item">
          <router-link
            style="text-decoration: none"
            :to="{ name: 'manager_job_uuid', params: { manager_job_uuid: recentPlacement.job_id } }"
            >{{ recentPlacement.job }}</router-link
          >
        </div>
      </popper>
    </td>
    <td id="location" nowrap>
      {{ recentPlacement.location.city }}, {{ recentPlacement.location.country }}
    </td>
    <td id="hired" nowrap>
      <popper
        trigger="hover"
        :options="{
          placement: 'top',
          modifiers: { offset: { offset: '-60,10px' } },
        }"
      >
        <div class="popper">
          {{
            recentPlacement.hired_date
              | formatDate({
                format: getManagerUserProfile.format_date,
                timezone: getManagerUserProfile.timezone,
                hasHourAndMinutes: true,
              })
          }}
        </div>
        <div slot="reference">
          {{
            recentPlacement.hired_date
              | formatDate({
                format: getManagerUserProfile.format_date,
                timezone: getManagerUserProfile.timezone,
                hasHourAndMinutes: false,
              })
          }}
        </div>
      </popper>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    recentPlacement: {
      type: Object,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('managerStoreModule', ['getManagerUserProfile']),
  },
  mounted() {
    // console.log(this.getUserProfile.format_date);
  },
};
</script>
